import { Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CurrencyFilterCard from "./CurrencyFilter/CurrencyFilterCard";
import CurrencyTable from "./CurrencyTable/CurrencyTable";
import { useDispatch } from "react-redux";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { useSelector } from "react-redux";
import Page404 from "../../../Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

interface CurrencyProps {
  oauthTokenHeader: any;
}

const tableHeadings = {
  currency_name: "Currency Name",
  currency_code: "Currency Code",
  currency_symbol: "Currency Symbol",
  created: "Created on",
  created_by: "Created By",
  modified: "Last edited",
  modified_by: "Edited By",
};

const Currency = ({ oauthTokenHeader }: CurrencyProps) => {
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [metaCurrencies, setMetaCurrencies] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewCurrencyPermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_currency_symbols"
  );

  useEffect(() => {
    const fetchMetaCurrenciesType = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaCurrencyType(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Entities:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchMetaCurrenciesType();
    }
  }, [oauthTokenHeader, dispatch]);

  if (!hasViewCurrencyPermission) {
    return <Page404 />;
  }

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Currencies List</Typography>
            <CurrencyFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <CurrencyTable
              tableHeadings={tableHeadings}
              oauthTokenHeader={oauthTokenHeader}
              loading={loading}
              metaCurrencies={metaCurrencies}
              setMetaCurrencies={setMetaCurrencies}
              selectedCurrency={selectedCurrency}
              setSelectedCurrency={setSelectedCurrency}
            />
          </Paper>
        </>
      )}
    </>
  );
};

export default Currency;
